import React from 'react';
import MainFooter from './MainFooter';
import BottomBar from './BottomBar';

const Footer = () => {
  return (
    <footer>
     {/*  <MainFooter /> */}
      <BottomBar />
    </footer>
  );
};

export default Footer;
